/* eslint-disable no-console */
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MaterialIcons,
  MenuItem,
  Select,
  Typography,
} from '@usehatchapp/material';
import PropTypes from 'prop-types';
import React from 'react';

const { Close } = MaterialIcons;

export const TIME_INTERVAL = 15;
const MINUTES_IN_DAY = 1440;
const INTERVALS = [];
for (let i = 0; i < MINUTES_IN_DAY; i += TIME_INTERVAL) {
  INTERVALS.push(i);
}

const timeToValue = ({ hour, minute }) => hour * 60 + minute;

const valueToTime = (time) => {
  const hour = Math.floor(time / 60);
  const minute = time % 60;
  return { hour, minute };
};

const formatDropdownTime = (time) => {
  const suffix = time >= MINUTES_IN_DAY / 2 ? 'PM' : 'AM';
  const hours =
    time >= MINUTES_IN_DAY / 2
      ? `${Math.floor(time / 60) - 12}`
      : `${Math.floor(time / 60)}`;
  const minutes = `${time % 60}`;
  return `${hours === '0' ? `12` : hours}:${
    minutes.length === 1 ? `00` : minutes
  } ${suffix}`;
};

const Interval = ({
  open,
  close,
  day,
  onChangeHours,
  editing,
  index,
  removeInterval,
}) => {
  return editing ? (
    <Grid container {...(index !== 0 ? { mt: 2 } : {})}>
      <FormControl sx={{ minWidth: '130px', ml: 2 }} size="small">
        <InputLabel>Open</InputLabel>
        <Select
          size="small"
          data-test-id="d8765049-8b8c-4f60-8059-0fa9beaf2580"
          label="Open"
          value={timeToValue(open)}
          onChange={({ target: { value } }) => {
            const { hour, minute } = valueToTime(value);
            onChangeHours({ day, hour, index, kind: 'open', minute });
          }}
          disabled={!editing}
          MenuProps={{ sx: { maxHeight: '400px' } }}
        >
          {INTERVALS.map((interval) => (
            <MenuItem key={interval} value={interval}>
              {formatDropdownTime(interval)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ minWidth: '130px', ml: 2 }} size="small">
        <InputLabel>Closed</InputLabel>
        <Select
          size="small"
          data-test-id="2439f2c9-f61b-40e9-818c-2dddf561979f"
          label="Closed"
          value={timeToValue(close)}
          onChange={({ target: { value } }) => {
            const { hour, minute } = valueToTime(value);
            onChangeHours({ day, hour, index, kind: 'close', minute });
          }}
          disabled={!editing}
          MenuProps={{ sx: { maxHeight: '400px' } }}
        >
          {INTERVALS.map((interval) => (
            <MenuItem key={interval} value={interval}>
              {formatDropdownTime(interval)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {index !== 0 ? (
        <IconButton
          data-test-id="91b4a16a-6a69-41e1-9cdd-c1b26b55edab"
          onClick={() => removeInterval({ close, open })}
        >
          <Close />
        </IconButton>
      ) : null}
    </Grid>
  ) : (
    <Typography sx={{ mr: 2 }}>
      {formatDropdownTime(timeToValue(open))} -{' '}
      {formatDropdownTime(timeToValue(close))}
    </Typography>
  );
};

export default Interval;

Interval.propTypes = {
  close: PropTypes.shape({ hour: PropTypes.number, minute: PropTypes.number })
    .isRequired,
  day: PropTypes.string.isRequired,
  editing: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onChangeHours: PropTypes.func.isRequired,
  open: PropTypes.shape({ hour: PropTypes.number, minute: PropTypes.number })
    .isRequired,
  removeInterval: PropTypes.func.isRequired,
};
